module.exports = require("./../../_gen/starling/rendering/VertexDataFormat");